/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Distinct_SitesInputs */

const en_landing_pricing_feature_distinct_sites = /** @type {(inputs: Landing_Pricing_Feature_Distinct_SitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each from a different website`)
};

const zh_landing_pricing_feature_distinct_sites = /** @type {(inputs: Landing_Pricing_Feature_Distinct_SitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每次需来自不同网站`)
};

/**
* | output |
* | --- |
* | "Each from a different website" |
*
* @param {Landing_Pricing_Feature_Distinct_SitesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_distinct_sites = /** @type {((inputs?: Landing_Pricing_Feature_Distinct_SitesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Distinct_SitesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_distinct_sites(inputs)
	return zh_landing_pricing_feature_distinct_sites(inputs)
});
export { landing_pricing_feature_distinct_sites as "landing.pricing.feature_distinct_sites" }